/**
 * Sacrasoul, cart email ask — behaviour (markup: snippets/cart-email-capture.liquid)
 *
 * Owner decision, Sho, 2026-09-25: Klaviyo knew 4 of 514 cart adders in 30
 * days, so the abandoned-basket flow almost never fired. Ask inside the cart
 * for the popup's own gift, SACRA10.
 *
 * The submit path is the welcome popup's, not a new one (assets/popup-email.js,
 * subscribeToKlaviyo + showSuccess): the same client subscriptions call to the
 * same list, the same consent-gated SSKlv.identify, the same /discount/ route
 * followed by a cart.js read before any money claim, the same fallback when the
 * code cannot be confirmed, and the same sacrasoul_popup=submitted cookie so the
 * popup never asks this person again. It is copied rather than imported because
 * the popup's file is a closure pinned by tests/dom/popup-subscription.test.cjs,
 * and refactoring a live, measured signup path to share twenty lines is the
 * riskier trade. Keep the two in step.
 *
 * Visibility: hidden unless the cart has items, carries no discount CODE
 * (automatic gift discounts do not count), the visitor has not signed up via
 * the popup, is not already known to Klaviyo (logged-in email, or a __kla_id
 * cookie holding an email or exchange id), and has no remembered SACRA10 (the
 * drawer already offers that one-tap in #sacrasoul-welcome-discount).
 * The cart engine calls window.SSCartEmail.sync(cart) on every authoritative
 * render (syncWelcomeDiscountOffer in assets/sacrasoul-cart-drawer.js).
 *
 * Nothing runs at load beyond binding listeners and one visibility check.
 */
(function () {
  'use strict';

  var root = document.getElementById('ss-cart-email');
  if (!root || window.SSCartEmail) return;

  var KLAVIYO_COMPANY_ID = 'VFiMuh';
  var KLAVIYO_LIST_ID = 'UGtiNP';
  var CUSTOM_SOURCE = 'Sacrasoul Cart Drawer';
  var COOKIE_NAME = 'sacrasoul_popup';
  var COOKIE_SUBMITTED = 'submitted';
  var COOKIE_DAYS = 30;
  var COOKIE_DAYS_SUBMITTED = 365;
  var WELCOME_CODE = 'SACRA10';
  var WELCOME_CODE_KEY = 'ss_welcome_code';
  var SHOWN_KEY = 'ss_cart_email_shown_visit';

  var d = root.dataset;
  var LOCALE = d.locale || 'en';
  /* The snippet renders routes.cart_url, which keeps the market prefix
     (/de-eu/, /cs-cz/). The fallback builds from the same root. */
  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var CART_JSON_URL = d.cartJsonUrl || (ROOT.replace(/\/?$/, '/') + 'cart.js');
  var T = {
    cta: d.tCta, loading: d.tLoading, badEmail: d.tBadEmail, needConsent: d.tNeedConsent,
    error: d.tError, applied: d.tApplied, fallback: d.tFallback, signed: d.tSigned || d.tFallback
  };

  var toggle = document.getElementById('ss-cart-email-toggle');
  var panel = document.getElementById('ss-cart-email-panel');
  var input = document.getElementById('ss-cart-email-input');
  var consent = document.getElementById('ss-cart-email-consent');
  var submitBtn = document.getElementById('ss-cart-email-submit');
  var errorMsg = document.getElementById('ss-cart-email-error');
  var doneMsg = document.getElementById('ss-cart-email-done');
  if (!toggle || !panel || !input || !consent || !submitBtn || !errorMsg || !doneMsg) return;

  var lastCart = window.SacrasoulCartInitialCart || null;
  var finished = false;   // submitted on this page: keep the thank-you, ignore eligibility
  var busy = false;
  var expandedEmitted = false;

  /* ---- analytics: the house provider-neutral bridge (see popup-email.js emitPopup) ---- */
  function emit(name, properties) {
    try {
      var props = properties || {};
      props.surface = 'drawer';
      props.locale = LOCALE;
      if (window.SSBehavior && typeof window.SSBehavior.emit === 'function') {
        window.SSBehavior.emit(name, props);
        return;
      }
      document.dispatchEvent(new CustomEvent('sacrasoul:behavior', { detail: { name: name, properties: props } }));
    } catch (e) {}
  }

  /* ---- cookies and memory, identical to popup-email.js ---- */
  function setCookie(name, value, days) {
    var dt = new Date();
    dt.setTime(dt.getTime() + days * 24 * 60 * 60 * 1000);
    document.cookie = name + '=' + value + ';expires=' + dt.toUTCString() + ';path=/;SameSite=Lax';
  }
  function getCookie(name) {
    var match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
    return match ? match[2] : null;
  }
  function rememberWelcomeCode() {
    try {
      localStorage.setItem(WELCOME_CODE_KEY, JSON.stringify({
        code: WELCOME_CODE, expiresAt: Date.now() + COOKIE_DAYS * 24 * 60 * 60 * 1000
      }));
    } catch (e) {}
    setCookie(WELCOME_CODE_KEY, WELCOME_CODE, COOKIE_DAYS);
  }
  function forgetWelcomeCode() {
    try { localStorage.removeItem(WELCOME_CODE_KEY); } catch (e) {}
    document.cookie = WELCOME_CODE_KEY + '=;Max-Age=0;path=/;SameSite=Lax';
  }
  function welcomeCodeRemembered() {
    /* Same reading as rememberedWelcomeCode() in sacrasoul-cart-drawer.js: an
       expired or malformed record is forgotten, not treated as remembered. */
    try {
      var stored = localStorage.getItem(WELCOME_CODE_KEY);
      if (stored) {
        var rec = null;
        try { rec = JSON.parse(stored); } catch (legacy) { rec = { code: stored }; }
        if (rec && rec.expiresAt && rec.expiresAt <= Date.now()) {
          localStorage.removeItem(WELCOME_CODE_KEY);
        } else if (rec && String(rec.code || '').toUpperCase() === WELCOME_CODE) {
          return true;
        }
      }
    } catch (e) {}
    return getCookie(WELCOME_CODE_KEY) === WELCOME_CODE;
  }

  /* ---- who is already known ---- */
  function knownToKlaviyo() {
    try { if (window.__ssKlv && window.__ssKlv.email) return true; } catch (e) {}
    /* klaviyo.js keeps its identity in __kla_id: base64 JSON. An email or an
       exchange id (set by a click from one of our emails) means Klaviyo can
       already write to this browser. Unreadable means unknown, not known. */
    try {
      var raw = getCookie('__kla_id');
      if (!raw) return false;
      var kla = JSON.parse(atob(decodeURIComponent(raw)));
      return !!(kla && (kla.$email || kla.$exchange_id || kla.email));
    } catch (e) { return false; }
  }

  /* A discount CODE, not any discount: the gift tiers ride automatic
     discounts, and those must not hide the ask. */
  function hasDiscountCode(cart) {
    if (!cart) return false;
    if ((cart.discount_codes || []).some(function (c) { return c && c.code && c.applicable !== false; })) return true;
    if ((cart.cart_level_discount_applications || []).some(function (a) { return a && a.type === 'discount_code'; })) return true;
    return (cart.items || []).some(function (item) {
      return (item.line_level_discount_allocations || []).some(function (a) {
        return a && a.discount_application && a.discount_application.type === 'discount_code';
      });
    });
  }

  function onCheckoutPath() {
    return /\/(pages\/)?checkouts?(\/|$)/.test(window.location.pathname || '');
  }

  function eligible(cart) {
    if (!cart || Number(cart.item_count || 0) <= 0) return false;
    if (onCheckoutPath()) return false;
    if (hasDiscountCode(cart)) return false;
    if (getCookie(COOKIE_NAME) === COOKIE_SUBMITTED) return false;
    if (welcomeCodeRemembered()) return false;
    if (knownToKlaviyo()) return false;
    return true;
  }

  function drawerOpen() {
    var drawer = document.getElementById('sacrasoul-cart-drawer');
    return !!(drawer && drawer.classList.contains('is-open'));
  }

  function shownThisVisit() {
    try { return sessionStorage.getItem(SHOWN_KEY) === '1'; } catch (e) { return false; }
  }

  function maybeEmitShown() {
    if (finished || root.hidden || !drawerOpen() || shownThisVisit()) return;
    try { sessionStorage.setItem(SHOWN_KEY, '1'); } catch (e) {}
    emit('cart_email_shown', { item_count: Number(lastCart && lastCart.item_count || 0) });
  }

  function sync(cart) {
    if (cart) lastCart = cart;
    if (finished) {
      root.hidden = !(lastCart && Number(lastCart.item_count || 0) > 0);
      return;
    }
    if (busy) return;
    var show = eligible(lastCart);
    if (!show && !root.hidden && root.contains(document.activeElement)) {
      /* never strand keyboard focus inside a block that is about to vanish */
      var cta = document.getElementById('sacrasoul-checkout');
      if (cta) cta.focus();
    }
    root.hidden = !show;
    if (show) maybeEmitShown();
  }

  /* ---- expand / collapse ---- */
  function setExpanded(open) {
    toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    panel.hidden = !open;
    root.classList.toggle('is-expanded', open);
    if (open) {
      if (!expandedEmitted) { expandedEmitted = true; emit('cart_email_expanded', {}); }
      input.focus();
    }
  }
  toggle.addEventListener('click', function () {
    setExpanded(toggle.getAttribute('aria-expanded') !== 'true');
  });
  panel.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !busy) {
      /* close the ask, not the whole drawer */
      e.stopPropagation();
      setExpanded(false);
      toggle.focus();
    }
  });

  /* ---- errors ---- */
  function clearError() {
    errorMsg.textContent = '';
    root.classList.remove('has-error');
    input.removeAttribute('aria-invalid');
    consent.removeAttribute('aria-invalid');
  }
  function showFieldError(text, field) {
    errorMsg.textContent = text;
    root.classList.add('has-error');
    if (field) {
      field.setAttribute('aria-invalid', 'true');
      field.focus();
    }
  }
  input.addEventListener('input', function () { if (input.getAttribute('aria-invalid')) clearError(); });
  consent.addEventListener('change', function () { if (consent.checked && consent.getAttribute('aria-invalid')) clearError(); });

  function fetchWithTimeout(url, options, timeout) {
    var controller = window.AbortController ? new AbortController() : null;
    var requestOptions = options || {};
    if (controller) requestOptions.signal = controller.signal;
    var timer = controller ? setTimeout(function () { controller.abort(); }, timeout || 8000) : null;
    return fetch(url, requestOptions).then(function (response) {
      if (timer) clearTimeout(timer);
      return response;
    }, function (error) {
      if (timer) clearTimeout(timer);
      throw error;
    });
  }

  /* When a.klaviyo.com never answers (status 0: a device or network dropping
     the third-party host; the popup lost 4 signups this way 14-28 Sep 2026),
     the storefront's own origin still does. Shopify's newsletter form is the
     footer's route: the consent is recorded in Shopify and Klaviyo's Shopify
     sync carries it into "Email List" (a Welcome trigger). A stored signup
     redirects to ?customer_posted=true; anything else is not a signup.
     Kept identical to the copy in assets/popup-email.js (tested). */
  function subscribeViaShopify(email, tag) {
    return new Promise(function (resolve, reject) {
      var base = ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/').replace(/\/?$/, '/');
      var form = document.createElement('form');
      form.method = 'post';
      form.action = base + 'contact';
      form.hidden = true;
      [['form_type', 'customer'], ['utf8', '\u2713'], ['contact[tags]', 'newsletter,' + tag], ['contact[email]', email]].forEach(function (pair) {
        var input = document.createElement('input');
        input.type = 'hidden';
        input.name = pair[0];
        input.value = pair[1];
        form.appendChild(input);
      });
      document.body.appendChild(form);
      var settled = false;
      var timer = setTimeout(function () {
        var error = new Error('Shopify signup timed out');
        error.status = 0;
        done(error);
      }, 20000);
      function done(error) {
        if (settled) return;
        settled = true;
        clearTimeout(timer);
        if (form.parentNode) form.parentNode.removeChild(form);
        if (error) reject(error); else resolve();
      }
      var sent = false;
      function send() {
        /* Shopify's page-level submit handler may call submit() again after
           the provider has; one signup is one post. */
        if (sent) return;
        sent = true;
        fetchWithTimeout(form.action, { method: 'POST', body: new FormData(form), credentials: 'same-origin' }, 15000)
          .then(function (response) {
            if (response.ok && /[?&]customer_posted=true/.test(response.url || '')) return done();
            var error = new Error('Shopify signup not stored');
            error.status = response.status;
            done(error);
          }, function (error) {
            var failure = new Error((error && error.message) || 'Shopify signup failed');
            failure.status = 0;
            done(failure);
          });
      }
      /* Shopify's bot protection answers a tokenless post with 400 "Missing
         CAPTCHA token". Its own script adds the token on submit and then calls
         the form's native submit(); this form's submit() sends that tokened
         form with fetch instead, so the page stays put and the answer can be
         read (a framed answer is refused: X-Frame-Options DENY). */
      form.submit = send;
      var captcha = window.Shopify && window.Shopify.captcha;
      if (captcha && typeof captcha.protect === 'function' && typeof form.requestSubmit === 'function') {
        try {
          captcha.protect(form, function () { form.requestSubmit(); });
        } catch (protectError) {
          send();
        }
      } else {
        send();
      }
    });
  }

  function cartHasWelcomeCode(cart) {
    if (!cart) return false;
    if ((cart.discount_codes || []).some(function (c) {
      return c && c.code && c.code.toUpperCase() === WELCOME_CODE && c.applicable !== false;
    })) return true;
    if ((cart.cart_level_discount_applications || []).some(function (a) {
      return a && a.title && a.title.toUpperCase() === WELCOME_CODE;
    })) return true;
    return (cart.items || []).some(function (item) {
      return (item.line_level_discount_allocations || []).some(function (a) {
        var application = a && a.discount_application;
        return application && application.title && application.title.toUpperCase() === WELCOME_CODE;
      });
    });
  }

  /* ---- the basket, re-told to Klaviyo under this person's name ----
     The abandoned-basket flow listens to the "Added to Cart" API metric.
     Every confirmed add already tells Klaviyo the basket (SSKlv.basket in
     assets/ss-klaviyo.js, 6 Oct 2026), but klaviyo.js holds that event back
     while the browser is anonymous, which is most of the people who reach
     this ask. Right after identify, the verified cart is told once more
     through the same door, so the payload (gift lines left out) and the
     $event_id are the add path's own: the same basket collapses to one event
     in Klaviyo. Source still says which door it came through. */
  function trackBasket(cart) {
    try {
      if (window.SSKlv && typeof window.SSKlv.basket === 'function') window.SSKlv.basket(cart, CUSTOM_SOURCE);
    } catch (e) {}
  }

  /* ---- success, discount, fallback: popup-email.js showSuccess() ---- */
  function finish(text) {
    busy = false;
    finished = true;
    doneMsg.textContent = text;
    panel.hidden = true;
    toggle.hidden = true;
    doneMsg.hidden = false;
    root.classList.remove('is-expanded');
    root.classList.add('is-done');
    /* the field that had focus is gone; hand focus to the sentence that replaced it */
    try { doneMsg.focus({ preventScroll: true }); } catch (e) { doneMsg.focus(); }
  }

  function showSuccess(via) {
    emit('cart_email_submitted', { via: via || 'klaviyo' });
    setCookie(COOKIE_NAME, COOKIE_SUBMITTED, COOKIE_DAYS_SUBMITTED);
    rememberWelcomeCode();
    submitBtn.textContent = T.loading;

    /* Shopify's discount route always redirects successfully, even for a code
       that cannot apply. Only cart.js is authoritative, so route status is
       ignored and nothing is claimed until the cart shows SACRA10. */
    var verifiedCart = null;
    fetchWithTimeout(ROOT.replace(/\/?$/, '/') + 'discount/' + encodeURIComponent(WELCOME_CODE), { method: 'GET', credentials: 'same-origin' }, 8000)
      .then(function () {
        return fetchWithTimeout(CART_JSON_URL, { credentials: 'same-origin' }, 8000);
      })
      .then(function (response) {
        if (!response.ok) throw new Error('Cart verification failed');
        return response.json();
      })
      .then(function (cart) {
        verifiedCart = cart;
        trackBasket(cart);
        if (Number(cart && cart.item_count || 0) === 0) {
          /* emptied while we worked: keep the code for later, as the popup does */
          finish(T.fallback);
          return;
        }
        if (!cartHasWelcomeCode(cart)) {
          forgetWelcomeCode();
          var notApplicable = new Error('Discount not applicable');
          notApplicable.reason = 'not_applicable';
          throw notApplicable;
        }
        forgetWelcomeCode();
        finish(T.applied);
        emit('cart_email_discount_applied', {});
        /* The drawer listens for this and re-reads the authoritative cart,
           so the SACRA10 chip and the lower total appear in place. */
        document.dispatchEvent(new CustomEvent('sacrasoul:discount-applied', { detail: { code: WELCOME_CODE } }));
      })
      .catch(function (error) {
        if (!verifiedCart) trackBasket(lastCart);
        /* On a network failure the code stays remembered (as in the popup),
           so the drawer's own one-tap SACRA10 banner offers it again on its
           next render. A code the cart refused was forgotten above. */
        var reason = (error && error.reason) || 'network';
        emit('cart_email_error', { stage: 'discount', reason: reason });
        /* Shopify refused the code for this basket: thank them, promise nothing.
           Only a network failure keeps the 'enter SACRA10 at checkout' line. */
        finish(reason === 'not_applicable' ? T.signed : T.fallback);
      });
  }

  function showError(status, detail) {
    busy = false;
    submitBtn.disabled = false;
    input.disabled = false;
    consent.disabled = false;
    submitBtn.textContent = T.cta;
    root.classList.remove('is-busy');
    showFieldError(T.error, input);
    emit('cart_email_error', Object.assign({ stage: 'klaviyo', status: status }, detail || {}));
  }

  function subscribe(email) {
    busy = true;
    submitBtn.disabled = true;
    input.disabled = true;
    consent.disabled = true;
    submitBtn.textContent = T.loading;
    root.classList.add('is-busy');
    clearError();
    var startedAt = Date.now();

    /* Klaviyo unreachable or failing on its side: take the first-party route.
       A 4xx is Klaviyo judging the address, which Shopify would too. */
    function fallBack(failure) {
      subscribeViaShopify(email, 'cart-drawer').then(function () {
        emit('cart_email_fallback', Object.assign({ ok: true }, failure));
        showSuccess('shopify');
      }, function (shopifyError) {
        showError(failure.status, Object.assign({
          fallback_status: (shopifyError && shopifyError.status) || 0
        }, failure));
      });
    }

    fetchWithTimeout('https://a.klaviyo.com/client/subscriptions/?company_id=' + KLAVIYO_COMPANY_ID, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'revision': '2026-07-15' },
      body: JSON.stringify({
        data: {
          type: 'subscription',
          attributes: {
            profile: {
              data: {
                type: 'profile',
                attributes: {
                  email: email,
                  locale: LOCALE,
                  properties: { language: LOCALE, signup_source: 'cart_drawer' }
                }
              }
            },
            custom_source: CUSTOM_SOURCE
          },
          relationships: { list: { data: { type: 'list', id: KLAVIYO_LIST_ID } } }
        }
      })
    }, 15000)
      .then(function (response) {
        if (!response.ok) {
          console.warn('Klaviyo subscription failed with status', response.status);
          if (response.status === 429 || response.status >= 500) {
            fallBack({ status: response.status, error: 'http', message: '', ms: Date.now() - startedAt, online: true });
            return;
          }
          showError(response.status);
          return;
        }
        /* Identity is optional tracking: an SDK failure cannot undo an
           accepted signup. Consent-gated inside SSKlv. */
        try { if (window.SSKlv) window.SSKlv.identify(email); } catch (identityError) {
          console.warn('Klaviyo browser identification unavailable');
        }
        /* The signup is accepted; a fault past this point is ours to log,
           never a reason to resubmit or to tell the shopper it failed. */
        try { showSuccess(); } catch (successError) {
          console.warn('Cart email success view failed:', successError);
        }
      }, function (error) {
        /* Only the request itself: a fault in the success path above must
           not send an accepted signup down the fallback a second time. */
        console.warn('Klaviyo subscription error:', error);
        fallBack({
          status: 0,
          error: String((error && error.name) || 'Error').slice(0, 40),
          message: String((error && error.message) || '').slice(0, 120),
          ms: Date.now() - startedAt,
          online: navigator.onLine !== false
        });
      });
  }

  function onSubmit() {
    if (busy || finished) return;
    var email = (input.value || '').trim();
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      showFieldError(T.badEmail, input);
      emit('cart_email_error', { stage: 'validation', reason: 'email' });
      return;
    }
    if (!consent.checked) {
      showFieldError(T.needConsent, consent);
      emit('cart_email_error', { stage: 'validation', reason: 'consent' });
      return;
    }
    subscribe(email);
  }
  submitBtn.addEventListener('click', onSubmit);
  input.addEventListener('keydown', function (e) {
    if (e.key === 'Enter') { e.preventDefault(); onSubmit(); }
  });

  /* The drawer opening is the impression moment; the engine's render (which
     calls sync) may land a frame later, so check once more after it. */
  document.addEventListener('sacrasoul:behavior', function (event) {
    var detail = event && event.detail;
    if (!detail || detail.name !== 'cart_opened') return;
    setTimeout(maybeEmitShown, 0);
  });

  window.SSCartEmail = { sync: sync };
  sync(lastCart);
})();
